"use client";

import { IBaseLabelValue } from "@/interfaces";
import { useRouter } from "next/navigation";
import { CustomButton, FlexBetween, FlexCenter, FlexCol } from "../../ui";
import { cn } from "@/lib";
import InputDataContent from "../inputDataContent";
import ResultContent from "../../resultContent";
import { routes } from "@/routes";
import { useTranslations } from "next-intl";
import DownloadPdf from "../../pdfTemplates/downloadPdf";
import { useRef } from "react";
import PdfTemplate from "@/components/pdfTemplates/pdfTemplate";
import { IRawPurchasedPostalCodeInquiryResData } from "@/interfaces/inquiries/governmental";

const PostalCodeInquiryDetails = ({
  data,
}: {
  data: IRawPurchasedPostalCodeInquiryResData;
}) => {
  const t = useTranslations("serviceResponseDetails");
  const router = useRouter();
  const { address, city, district, floor, no, postalCode, province, street } =
    data.data.data;
  const { code } = data.data.input;

  const inputContent: IBaseLabelValue[] = [
    {
      label: t("postalCodeInquiry.inputLabel"),
      value: code,
    },
  ];
  const cleanAddress =
    address
      ?.split("،")
      .filter((item) => item && !item.includes("null"))
      .join("،") || "-";
  const resultContent: IBaseLabelValue[] = [
    {
      label: t("postalCodeInquiry.province"),
      value: province || "-",
    },
    {
      label: t("postalCodeInquiry.district"),
      value: district || "-",
    },
    {
      label: t("postalCodeInquiry.city"),
      value: city || "-",
    },
    {
      label: t("postalCodeInquiry.street"),
      value: street || "-",
    },
    {
      label: t("postalCodeInquiry.floor"),
      value: floor ? (floor === "0" ? "همکف" : floor) : "-",
    },
    {
      label: t("postalCodeInquiry.no"),
      value: no || "-",
    },
    {
      label: t("postalCodeInquiry.address"),
      value: cleanAddress,
    },
  ];
  const pdfContentRef = useRef<HTMLDivElement>(null);
  return (
    <div className="shadow-main from-teal-ocean relative basis-[500px] rounded-2xl bg-linear-to-b to-transparent p-[2px] lg:basis-[640px]">
      <FlexCol className="items-stretch rounded-2xl bg-white p-8">
        <h2 className="mb-8 text-center font-bold lg:text-lg">
          {t("postalCodeInquiry.title")}
        </h2>

        <InputDataContent content={inputContent} />
        <FlexBetween className="mb-3 items-center">
          <h2 className="text-center text-lg font-bold">
            {t("postalCodeInquiry.resultTitle")}
          </h2>
          <DownloadPdf
            id="postal-code-inquiry-download-pdf"
            useHtmlToPdf={true}
            htmlContentRef={pdfContentRef}
            fileName={`استعلام کد پستی ${postalCode}`}
          />
        </FlexBetween>
        <ResultContent content={resultContent} />
        <FlexCenter className="flex flex-col justify-center md:flex-row md:gap-6">
          <DownloadPdf
            id="postal-code-inquiry-download-pdf"
            useHtmlToPdf={true}
            htmlContentRef={pdfContentRef}
            fileName={`استعلام کد پستی ${postalCode}`}
            className="order-2 flex cursor-pointer items-center justify-center rounded-md border-none! bg-red-700 px-8 py-[6px] text-white transition-all hover:bg-red-800 md:order-1 lg:rounded-lg lg:py-[8px]"
            showIcon={false}
            labelClass="text-xs lg:text-sm xl:text-base font-medium"
          />
          <div className="order-1 mb-4 flex gap-4 md:order-2 md:m-0 xl:gap-6">
            <CustomButton
              id="details-postal-code-inquiry-back"
              className={cn("w-fit bg-gray-500")}
              onClick={() =>
                router.push(routes.main.INQUIRY_HISTORY.primaryPath)
              }
            >
              {t("companyInformationInquiry.backButton")}
            </CustomButton>
            <CustomButton
              id="details-postal-code-inquiry-new-request"
              onClick={() =>
                router.push(routes.services.Postal_Code_Inquiry.rewritePath)
              }
              className={cn("bg-primary-main mx-auto w-fit px-8! text-white")}
            >
              {t("newRequest")}
            </CustomButton>
          </div>
        </FlexCenter>
      </FlexCol>
      {/* This div will be used for PDF generation - DetailCreditCard style */}
      <div
        ref={pdfContentRef}
        style={{
          position: "fixed",
          left: "-9999px",
          top: "-9999px",
          width: "800px",
          fontFamily: "IRANYekan, sans-serif",
          margin: "2rem auto",
        }}
      >
        <PdfTemplate
          tableTitle={`استعلام کد پستی ${postalCode}`}
          resultContent={resultContent}
          code={data.code}
          dateTime={data.created_at}
        />
      </div>
    </div>
  );
};

export default PostalCodeInquiryDetails;
